import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import OrderButton from './orderButton';
import { OrderType, orderTypeDisplayName } from '../../../../types';
import AskQuestionButton from '../../askQuestionButton';
import useLayoutStyles from '../../../layout/useLayoutStyles';
import useQuestionPageStyles from '../useQuestionPageStyles';

/**
 * Interface representing the props for the QuestionHeader component.
 *
 * titleText - The title text displayed at the top of the header.
 * qcnt - The number of questions to be displayed in the header.
 * setQuestionOrder - A function that sets the order of questions based on the selected message.
 */
interface QuestionHeaderProps {
  titleText: string;
  qcnt: number;
  questionOrder: OrderType;
  setQuestionOrder: (order: OrderType) => void;
}

/**
 * QuestionHeader component displays the header section for a list of questions.
 * It includes the title, a button to ask a new question, the number of the quesions,
 * and buttons to set the order of questions.
 *
 * @param titleText - The title text to display in the header.
 * @param qcnt - The number of questions displayed in the header.
 * @param setQuestionOrder - Function to set the order of questions based on input message.
 */
const QuestionHeader = ({
  titleText,
  qcnt,
  questionOrder,
  setQuestionOrder,
}: QuestionHeaderProps) => {
  const { classes: layoutClasses } = useLayoutStyles();
  const { classes: questionPageClasses } = useQuestionPageStyles();

  return (
    <div>
      <div className={`${layoutClasses.spaceBetween} ${layoutClasses.rightPadding}`}>
        <div className={layoutClasses.boldTitle}>{`Displaying: ${titleText} (${qcnt})`}</div>
        <ToggleButtonGroup
          value={questionOrder}
          exclusive
          onChange={(event, newOrder) => {
            if (newOrder !== null) {
              setQuestionOrder(newOrder);
            }
          }}
          aria-label='question order'
          className={questionPageClasses.btns}>
          {Object.keys(orderTypeDisplayName).map(order => (
            <OrderButton
              key={order}
              orderType={order as OrderType}
              questionOrder={questionOrder}
              setQuestionOrder={setQuestionOrder}
            />
          ))}
        </ToggleButtonGroup>
        <AskQuestionButton />
      </div>
    </div>
  );
};

export default QuestionHeader;
